import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import CrearCompromisoLayout
    from "../../../components/CrearCompromisoLayout";
import { TIPOSIDENTIFICACION } from "../../../constants/enum";

import LoadingScreen from "react-loading-screen";
import logo from "../../../../../assets/img/logo/logo_aig_login-2.png";
import ConfirmDialog from "../../../../../components/Compras/ConfirmDialog";

import {
    listarBrokers,
    setDatosNuevoCompromiso,
    limpiarNuevoCompromiso,
    consultarCliente,
    eliminarLineasCliente
} from "../../../redux/aCompromisos";

import {
    selectBrokers,
    selectNuevoCompromiso,
    selectConsultarClienteIsLoading
} from "../../../redux/selectors";

const ROLES_ADMINISTRATIVOS = [
    "admin-user",
    "soporte-user",
    "distribucion-user",
    "aglutinador-user"
];


const InformacionSolicitante = () => {
    const dispatch = useDispatch();

    const datosUsuario = useSelector((state) => state.datosUsuarios.dataUsuario);
    const consultarClienteIsLoading = useSelector(selectConsultarClienteIsLoading);
    const tipoUsuario = datosUsuario && datosUsuario.usu_tipo_usuario;
    const esAglutinador = tipoUsuario === 'aglutinador-user';
    const idUsuario = esAglutinador && datosUsuario && datosUsuario.cliCodigoCore || null;
    const puedeSeleccionarBroker = ROLES_ADMINISTRATIVOS.includes(tipoUsuario);
    const nuevoCompromiso = useSelector(selectNuevoCompromiso);
    const [brokerSolicitante, setBrokerSolicitante] = useState(nuevoCompromiso.brokerSolicitante || null);
    const brokers = useSelector(selectBrokers);
    const [brokersFiltrados, setBrokersFiltrados] = useState([]);
    const [mostrarConfirmacionCambioCliente, setMostrarConfirmacionCambioCliente] = useState(false);
    const [emailAsesor, setEmailAsesor] = useState(nuevoCompromiso.emailAsesor || "");
    const [tipoIdentificacion, setTipoIdentificacion] = useState(nuevoCompromiso.tipoIdentificacion || null);
    const [numeroIdentificacion, setNumeroIdentificacion] = useState(nuevoCompromiso.numeroIdentificacion || "");
    const [eliminandoLineas, setEliminandoLineas] = useState(false);
    const brokerUsuario = {
        ruc:
            datosUsuario && datosUsuario.brokerRUC
                ? datosUsuario.brokerRUC
                : "",

        nombre:
            datosUsuario && datosUsuario.brokerNombre
                ? datosUsuario.brokerNombre.trim()
                : "",

        nombreCompleto:
            datosUsuario &&
                datosUsuario.brokerRUC &&
                datosUsuario.brokerNombre
                ? datosUsuario.brokerRUC +
                " - " +
                datosUsuario.brokerNombre.trim()
                : "",
        id:datosUsuario && datosUsuario.cliCodigoCore
                ? datosUsuario.cliCodigoCore.trim()
                : "",
    };
    const [errores, setErrores] = useState({});
    const getSchemaPantalla1 = () => {
        return Yup.object({
            emailAsesor: Yup
                .string()
                .trim()
                .lowercase()
                .matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "El email no es válido"
                )
                .required("El email es obligatorio")
        });
    };

    useEffect(() => {

        if (puedeSeleccionarBroker) {
            dispatch(listarBrokers(idUsuario));
        } else {
            if (!nuevoCompromiso.brokerSolicitante) {

                setBrokerSolicitante(
                    brokerUsuario
                );
            }

            if (!nuevoCompromiso.emailAsesor) {

                setEmailAsesor(
                    datosUsuario &&
                        datosUsuario.correo
                        ? datosUsuario.correo
                        : ""
                );
            }
        }

    }, [
        dispatch,
        puedeSeleccionarBroker,
        nuevoCompromiso.brokerSolicitante,
        nuevoCompromiso.emailAsesor
    ]);

    const buscarBrokers = (event) => {

        const termino = event.query
            ? event.query.trim().toLowerCase()
            : "";

        const resultados = brokers.filter((broker) => {

            const texto =
                broker.nombreCompleto
                    ? broker.nombreCompleto.toLowerCase()
                    : "";

            return texto.includes(termino);
        });

        setBrokersFiltrados(resultados);
    };

    const seleccionarBroker = (event) => {
        const broker = event.value;
        setBrokerSolicitante(broker);

        if (broker && broker.email) {
            setEmailAsesor(broker.email);
        } else {
            setEmailAsesor("");
        }
    };

    const handleTipoIdentificacion = (event) => {

        setTipoIdentificacion(event.value);

        // Al cambiar el tipo limpiamos el número
        setNumeroIdentificacion("");
    };

    const handleNumeroIdentificacion = (event) => {

        let valor = event.target.value;

        if (!tipoIdentificacion) {
            return;
        }

        if (tipoIdentificacion === "CEDULA") {

            valor = valor
                .replace(/\D/g, "")
                .substring(0, 10);

        } else if (tipoIdentificacion === "RUC") {

            valor = valor
                .replace(/\D/g, "")
                .substring(0, 13);

        } else if (tipoIdentificacion === "PASAPORTE") {

            valor = valor
                .replace(/[^a-zA-Z0-9]/g, "")
                .substring(0, 15);
        }

        setNumeroIdentificacion(valor);
    };

    const numeroIdentificacionValido = () => {

        if (!tipoIdentificacion || !numeroIdentificacion) {
            return false;
        }

        if (tipoIdentificacion === "CEDULA") {
            return numeroIdentificacion.length === 10;
        }

        if (tipoIdentificacion === "RUC") {
            return numeroIdentificacion.length === 13;
        }

        if (tipoIdentificacion === "PASAPORTE") {
            return (
                numeroIdentificacion.length >= 5 &&
                numeroIdentificacion.length <= 15
            );
        }

        return false;
    };

    const formularioValido = () => {

        if (!brokerSolicitante) {
            return false;
        }

        if (!tipoIdentificacion) {
            return false;
        }

        if (!numeroIdentificacionValido()) {
            return false;
        }

        if (!emailAsesor) {
            return false;
        }

        return true;
    };

    const existeCompromiso =
        !!nuevoCompromiso.idCompromiso;

    const titularCambio =
        nuevoCompromiso.tipoIdentificacion !== tipoIdentificacion ||
        nuevoCompromiso.numeroIdentificacion !== numeroIdentificacion;

    const consultarNuevoTitular = async () => {

        const cliente = await dispatch(
            consultarCliente(
                tipoIdentificacion,
                numeroIdentificacion
            )
        );

        const datosCliente = cliente || {};

        dispatch(
            setDatosNuevoCompromiso({
                brokerSolicitante,
                emailAsesor,
                tipoIdentificacion,
                numeroIdentificacion,

                nombreCompleto:
                    datosCliente.nombreCompleto || "",

                emailCliente:
                    datosCliente.email || "",

                telefono:
                    datosCliente.telefono || "",

                celular:
                    datosCliente.celular || "",

                stupendo:
                    datosCliente.stupendo === true,

                dataTitular:
                    datosCliente.dataTitular || [],

                clienteEncontrado:
                    datosCliente.encontrado === true,

                origenCliente:
                    datosCliente.origen || "MANUAL",

                //lineasNegocio: []
            })
        );

        history.push(
            "/compromisos/crear/lineas-negocio"
        );
    };

    const handleConsultar = async () => {

        try {

            await getSchemaPantalla1().validate(
                {
                    emailAsesor
                },
                {
                    abortEarly: false
                }
            );

            setErrores({});

            if (!formularioValido()) {
                return;
            }
            if (!existeCompromiso) {

                await consultarNuevoTitular();

                return;
            }

            if (!titularCambio) {

                dispatch(
                    setDatosNuevoCompromiso({
                        brokerSolicitante,
                        emailAsesor
                    })
                );

                history.push(
                    "/compromisos/crear/lineas-negocio"
                );

                return;
            }

            setMostrarConfirmacionCambioCliente(true);

        } catch (error) {

            const erroresFormulario = {};

            if (error.inner) {
                error.inner.forEach((item) => {

                    if (!erroresFormulario[item.path]) {
                        erroresFormulario[item.path] =
                            item.message;
                    }

                });
            }

            setErrores(erroresFormulario);
        }
    };


    const history = useHistory();

    const confirmarCambioCliente = async () => {
        try {

            setEliminandoLineas(true);

            const respuestaEliminar = await dispatch(
                eliminarLineasCliente(
                    nuevoCompromiso.idCompromiso
                )
            );

            if (
                !respuestaEliminar ||
                respuestaEliminar.success === false
            ) {
                return;
            }

            dispatch(
                setDatosNuevoCompromiso({
                    lineasNegocio: []
                })
            );

            await consultarNuevoTitular();
        } catch (error) {

            console.error(
                "Error al cambiar cliente",
                error
            );
        } finally {

            setEliminandoLineas(false);
        }
    };



    const handleAnterior = () => {
        dispatch(limpiarNuevoCompromiso());
        history.push("/compromisos/listado");
    }

    return (
        <LoadingScreen
            loading={
                consultarClienteIsLoading ||
                eliminandoLineas
            }
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text={
                eliminandoLineas
                    ? "Actualizando información del compromiso..."
                    : "Consultando información del cliente..."
            }
        >
            <CrearCompromisoLayout
                activeStep={1}
                tituloPaso="Información del solicitante"
            >


                {/* BRÓKER */}
                <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        <FormGroup>

                            <Label>
                                Bróker solicitante
                                <span className="text-danger">
                                    {" "}*
                                </span>
                            </Label>

                            {puedeSeleccionarBroker ? (

                                <AutoComplete
                                    value={brokerSolicitante}
                                    suggestions={brokersFiltrados}
                                    completeMethod={buscarBrokers}
                                    onChange={seleccionarBroker}
                                    field="nombreCompleto"
                                    placeholder="Seleccione un bróker"
                                    dropdown
                                    className="w-100"
                                />

                            ) : (

                                <InputText
                                    value={
                                        brokerSolicitante
                                            ? brokerSolicitante.nombreCompleto
                                            : ""
                                    }
                                    disabled
                                    className="w-100"
                                />

                            )}

                        </FormGroup>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        {/* EMAIL */}

                        <FormGroup>

                            <Label>
                                Email asesor
                            </Label>
                            <InputText
                                value={emailAsesor}
                                onChange={(event) =>
                                    setEmailAsesor(event.target.value)
                                }
                                disabled={!puedeSeleccionarBroker}
                                className={
                                    "w-100 " +
                                    (errores.emailAsesor
                                        ? "p-invalid"
                                        : "")
                                }
                                placeholder="Correo del bróker"
                            />

                            {errores.emailAsesor && (
                                <small className="text-danger">
                                    {errores.emailAsesor}
                                </small>
                            )}

                        </FormGroup>
                    </Col>
                </Row>




                <Row>
                    <Col lg={6} md={6} sm={6} xs={12}>

                        {/* TIPO IDENTIFICACIÓN */}

                        <FormGroup>

                            <Label>
                                Tipo de identificación
                                <span className="text-danger">
                                    {" "}*
                                </span>
                            </Label>

                            <Dropdown
                                value={tipoIdentificacion}
                                options={TIPOSIDENTIFICACION}
                                onChange={handleTipoIdentificacion}
                                placeholder="Seleccione"
                                className="w-100"
                            />

                        </FormGroup>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        {/* NÚMERO IDENTIFICACIÓN */}

                        <FormGroup>

                            <Label>
                                Número de identificación
                                <span className="text-danger">
                                    {" "}*
                                </span>
                            </Label>

                            <InputText
                                value={numeroIdentificacion}
                                onChange={
                                    handleNumeroIdentificacion
                                }
                                disabled={!tipoIdentificacion}
                                className="w-100"
                                placeholder="Ingrese el número de identificación"
                            />

                            {tipoIdentificacion === "CEDULA" && (
                                <small className="text-muted">
                                    Ingrese 10 dígitos.
                                </small>
                            )}

                            {tipoIdentificacion === "RUC" && (
                                <small className="text-muted">
                                    Ingrese 13 dígitos.
                                </small>
                            )}

                            {tipoIdentificacion === "PASAPORTE" && (
                                <small className="text-muted">
                                    Ingrese entre 5 y 15 caracteres
                                    alfanuméricos.
                                </small>
                            )}

                        </FormGroup>
                    </Col>
                </Row>

                <div className="compromiso-actions">

                    <Button
                        className="compromiso-button compromiso-button-regresar"
                        onClick={handleAnterior}
                    >
                        <span aria-hidden="true" className="compromiso-button-icon">‹</span>
                        Regresar
                    </Button>

                    <Button
                        className="compromiso-button compromiso-button-consultar"
                        disabled={!formularioValido()}
                        onClick={handleConsultar}
                    >
                        Consultar
                    </Button>


                </div>

            </CrearCompromisoLayout>
            <ConfirmDialog
                isOpen={mostrarConfirmacionCambioCliente}
                toggle={() =>
                    setMostrarConfirmacionCambioCliente(
                        !mostrarConfirmacionCambioCliente
                    )
                }
                message={
                    <>
                        El compromiso ya se encuentra registrado con otro cliente.
                        <br />
                        <br />
                        Si cambia el cliente, las líneas de negocio registradas serán
                        eliminadas y deberán seleccionarse nuevamente.
                        <br />
                        <br />
                        ¿Desea continuar con el cambio de cliente?
                    </>
                }
                onConfirm={confirmarCambioCliente}
            />
        </LoadingScreen>
    );
};

export default InformacionSolicitante;